import * as React from 'react';

import * as styles from './CardHeaderLayout.css';

export const CardHeaderLayout = ({ children }: React.PropsWithChildren) => {
  return <div className={styles['container']}>{children}</div>;
};
